<template>
    <ui-modal-message-v-2
        :name='name'
        :cancel-button="true"
        :color-square="'primary'"
        icon-square
        :dynamic-icon="'ui-funnil'"
        :width-dynamic-icon="24"
        :height-dynamic-icon="16"
        @close-modal="handleCloseModal"
    >
        <template #title>
            <div class="header-container">
                <span class="first-title">Alteração de Etapa e Status</span>
                <span class="second-title">
                    Selecione a nova etapa e status para{{deals.length > 1 ? ' os ' : ' o '}} 
                    <span class="second-title-weight">
                        {{ deals.length > 1 ? deals.length : "" }} {{deals.length > 1 ? 'negócios ' : 'negócio '}}
                    </span>
                    {{deals.length > 1 ? 'selecionados.' : 'selecionado.'}}       
                </span>
            </div>

            <div class="diviser"/>
        </template>
        <template #text>
            <div class="text-container">
                <div class="selects-container">
                    <div class="stage-select">
                        <ui-select-v-2
                            v-model="selectedStageId"
                            :data="filterStages"
                            :loading="loading"
                            label="Etapa"
                            item-label="name"
                            return-value="id"
                        />
                    </div>
                    <div class="status-select">
                        <ui-select-v-2
                            v-model="selectedStageStatusId"
                            :data="filterStatusByStage"
                            :disabled="disabledStatus"
                            :loading="loading"
                            label="Status"
                            item-label="name"
                            return-value="id"
                        /> 
                    </div>
                </div>
                <div class="diviser"/>
            </div>


            <uiCodeConfirm 
                ref="codeConfirmRef"
                :code-name="name"
                @code-validated="handleCodeValidation"
            />
           
        </template>
        <template #footer>
            <ui-button
                :design="'md success'"
                :disabled="!isFormValid"
                @click="onSubmit"
            >
                Confirmar
            </ui-button>
        </template>
    </ui-modal-message-v-2>
</template>

<script>
import { uiModalMessageV2 } from '@/components/ui/modal'
import { uiSelectV2 } from '@/components/ui/form'
import { uiButton } from '@/components/ui/buttons'
import { funnel } from '@/services/axios'
import { uiCodeConfirm } from '@/components/ui'

export default {
  name: 'change-stage-status-modal-bulk',

  components: {
    uiModalMessageV2,
    uiSelectV2,
    uiButton,
    uiCodeConfirm,
  },

  props: {
    name: {
      type: String,
      default: 'change-stage-status-modal-bulk'
    },
    deals: {
        type: Array,
        required: true
    },
    closeModalAction: {
      type: Function,
      default: null
    },
  },

  data() {
    return {
        allStages: [],
        selectedStageId: null,
        selectedStageStatusId: null,
        isCodeValid: false,
        isBulkAction: false,
        loading:  false
    }
  },

  computed: {
        filterStages() {
            return this.allStages
        },

        filterStatusByStage() {
          if (!this.selectedStageId) return [];

          const selectedStage = this.allStages.find(stage => stage.id === this.selectedStageId);
          return selectedStage && Array.isArray(selectedStage.status)
            ? selectedStage.status
            : [];
        },

        disabledStatus() {
            return this.filterStatusByStage.length === 0
        },

        isFormValid() {
            const isSelectedStage = !!this.selectedStageId;
            const needStatus = this.filterStatusByStage.length > 0;
            const isValidSatus = needStatus ? !!this.selectedStageStatusId : true;
            return this.isCodeValid && isSelectedStage && isValidSatus;
        },

        selectedStageName() {
            return this.allStages.find(s => s.id === this.selectedStageId)?.name || ''
        },
        selectedStageStatusName() {
            return this.filterStatusByStage.find(s => s.id === this.selectedStageStatusId)?.name || ''
        }
    },

    mounted() {
        this.$root.$on(`modal-msg-open-${this.name}`, this.getAllStages)
    },

    beforeDestroy() {
        this.$root.$off(`modal-msg-open-${this.name}`, this.getAllStages)
    },

    methods: {
        getAllStages() {
          this.loading = true;

          funnel.getStagesV2()
            .then(({ data }) => {
              if (data.status === 'success') {
                this.allStages = data.data;
              }
            })
            .catch((error) => {
              if (error.data?.msg) {
                this.$mx_alertError(error.data.msg);
              } else {
                this.$mx_alertError(error);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        },
        
        handleCloseModal() {
        if (this.closeModalAction) this.closeModalAction()
            this.selectedStageId = null
            this.selectedStageStatusId = null
            this.isCodeValid = false

            this.$nextTick(() => {
                this.$refs.codeConfirmRef?.resetCode()
            })
        },

        onSubmit() {
          this.isBulkAction = true;
                
          const stage = this.allStages.find(stage => stage.id === this.selectedStageId);
          const status = stage?.status?.find(status => status.id === this.selectedStageStatusId);
                
          const stageName = stage?.name || '';
          const statusName = status?.name || '';
                
          this.$emit('bulk-step-data', {
            stage: {
                id: this.selectedStageId,
                name: this.selectedStageName
            },
            status: {
                id: this.selectedStageStatusId,
                name: this.selectedStageStatusName
            }
          });
      
          this.$root.$emit(`modal-msg-close-${this.name}`);
        },

        handleCodeValidation({ name, isValid }) {
            if (name === this.name) {
                this.isCodeValid = isValid;
            }
        },
    }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>